<div class="modal-header">
  <h4 class="modal-title">
    <ng-container *ngIf="inputCondition !== null">
      Edit Inbox Condition
    </ng-container>
    <ng-container *ngIf="inputCondition === null">
      Add Inbox Condition
    </ng-container>
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body pb-0">

  <div class="form-group">
    <label for="condition_type">Condition Type</label>
    <select id="condition_type"
            class="custom-select"
            name="condition_type"
            [(ngModel)]="condition.condition_type"
            (ngModelChange)="handleConditionTypeChange()">
      <option [ngValue]="null" disabled class="disabled">
        Select a condition type
      </option>
      <option *ngFor="let conditionType of Object.values(CustomInboxConditionType)"
              [ngValue]="conditionType">
        {{ getCustomInboxConditionTypeDescription(conditionType) }}
      </option>
    </select>
    <div class="form-text text-danger">{{ errors.condition_type }}</div>
  </div>

  <ng-container *ngIf="condition.condition_type === CustomInboxConditionType.accountAge">

    <div class="form-group">
      <label>Minimum Account Age (optional)</label>
      <div class="row">
        <div class="col-6">
          <div class="input-group">
            <input id="min_age_months"
                   name="min_age_months"
                   type="number"
                   class="form-control"
                   min="1" step="1"
                   [(ngModel)]="condition.parameters.min_age_months">
            <div class="input-group-append">
              <span class="input-group-text">months</span>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="input-group">
            <input id="min_age_days"
                   name="min_age_days"
                   type="number"
                   class="form-control"
                   min="1" step="1"
                   [(ngModel)]="condition.parameters.min_age_days">
            <div class="input-group-append">
              <span class="input-group-text">days</span>
            </div>
          </div>
        </div>
      </div>
      <div class="form-text text-danger">{{ errors.min_age_months }}</div>
      <div class="form-text text-danger">{{ errors.min_age_days }}</div>
    </div>

    <div class="form-group">
      <label>Maximum Account Age (optional)</label>
      <div class="row">
        <div class="col-6">
          <div class="input-group">
            <input id="max_age_months"
                   name="max_age_months"
                   type="number"
                   class="form-control"
                   min="1" step="1"
                   [(ngModel)]="condition.parameters.max_age_months">
            <div class="input-group-append">
              <span class="input-group-text">months</span>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="input-group">
            <input id="max_age_days"
                   name="max_age_days"
                   type="number"
                   class="form-control"
                   min="1" step="1"
                   [(ngModel)]="condition.parameters.max_age_days">
            <div class="input-group-append">
              <span class="input-group-text">days</span>
            </div>
          </div>
        </div>
      </div>
      <div class="form-text text-danger">{{ errors.max_age_months }}</div>
      <div class="form-text text-danger">{{ errors.max_age_days }}</div>
    </div>

  </ng-container>

  <ng-container *ngIf="condition.condition_type === CustomInboxConditionType.checkInCount">

    <div class="form-group">
      <label for="min_check_in_count">
        Minimum Check-In Count (optional)
      </label>
      <input id="min_check_in_count"
             name="min_check_in_count"
             type="number"
             class="form-control"
             min="1" step="1"
             [(ngModel)]="condition.parameters.min_check_in_count">
      <div class="form-text text-danger">{{ errors.min_check_in_count }}</div>
    </div>

    <div class="form-group">
      <label for="max_check_in_count">
        Maximum Check-In Count (optional)
      </label>
      <input id="max_check_in_count"
             name="max_check_in_count"
             type="number"
             class="form-control"
             min="1" step="1"
             [(ngModel)]="condition.parameters.max_check_in_count">
      <div class="form-text text-danger">{{ errors.max_check_in_count }}</div>
    </div>

    <div class="form-group">
      <label>Time Period (optional)</label>
      <div class="row">
        <div class="col-6">
          <div class="input-group">
            <input id="time_period_months"
                   name="time_period_months"
                   type="number"
                   class="form-control"
                   min="1" step="1"
                   [(ngModel)]="condition.parameters.time_period_months">
            <div class="input-group-append">
              <span class="input-group-text">months</span>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="input-group">
            <input id="time_period_days"
                   name="time_period_days"
                   type="number"
                   class="form-control"
                   min="1" step="1"
                   [(ngModel)]="condition.parameters.time_period_days">
            <div class="input-group-append">
              <span class="input-group-text">days</span>
            </div>
          </div>
        </div>
      </div>
      <small class="form-text text-muted">
        The time period over which the check-ins must have occurred. Leave this blank to check against the customers' total check-in count.
      </small>
      <div class="form-text text-danger">{{ errors.time_period_months }}</div>
      <div class="form-text text-danger">{{ errors.time_period_days }}</div>
    </div>

    <div class="form-group">
      <label for="location_id">Check-In Location</label>
      <select id="location_id"
              name="location_id"
              class="custom-select"
              [(ngModel)]="condition.parameters.location_id">
        <option [ngValue]="undefined">
          Any Location
        </option>
        <option *ngFor="let location of locations"
                [ngValue]="location.id">
          {{ location.name }}
        </option>
      </select>
      <div class="form-text text-danger">{{ errors.location_id }}</div>
    </div>

  </ng-container>

  <ng-container *ngIf="condition.condition_type === CustomInboxConditionType.customerAge">

    <div class="form-group">
      <label for="min_age">
        Minimum Customer Age (optional)
      </label>
      <input id="min_age"
             name="min_age"
             type="number"
             class="form-control"
             min="1" step="1"
             [(ngModel)]="condition.parameters.min_age">
      <div class="form-text text-danger">{{ errors.min_age }}</div>
    </div>

    <div class="form-group">
      <label for="max_age">
        Maximum Customer Age (optional)
      </label>
      <input id="max_age"
             name="max_age"
             type="number"
             class="form-control"
             min="1" step="1"
             [(ngModel)]="condition.parameters.max_age">
      <div class="form-text text-danger">{{ errors.max_age }}</div>
    </div>

  </ng-container>

  <ng-container *ngIf="condition.condition_type === CustomInboxConditionType.hasAssignedEntryPass">

    <div class="form-group">
      <label for="min_number_of_uses_remaining">
        Minimum Number of Uses Remaining (optional)
      </label>
      <input id="min_number_of_uses_remaining"
             name="min_number_of_uses_remaining"
             type="number"
             class="form-control"
             min="1" step="1"
             [(ngModel)]="condition.parameters.min_number_of_uses_remaining">
      <div class="form-text text-danger">{{ errors.min_number_of_uses_remaining }}</div>
    </div>

    <div class="form-group">
      <label for="max_number_of_uses_remaining">
        Maximum Number of Uses Remaining (optional)
      </label>
      <input id="max_number_of_uses_remaining"
             name="max_number_of_uses_remaining"
             type="number"
             class="form-control"
             max="1" step="1"
             [(ngModel)]="condition.parameters.max_number_of_uses_remaining">
      <div class="form-text text-danger">{{ errors.max_number_of_uses_remaining }}</div>
    </div>

    <div class="form-group">
      <label for="entry_pass_id">Entry Pass Type</label>
      <select id="entry_pass_id"
              name="entry_pass_id"
              class="custom-select"
              [(ngModel)]="condition.parameters.entry_pass_id">
        <option [ngValue]="undefined">
          Any Type
        </option>
        <option *ngFor="let entryPass of entryPasses"
                [ngValue]="entryPass.id">
          {{ entryPass.name }}
          <ng-container *ngIf="entryPass.status !== EntryPassStatus.active">
            ({{ getEntryPassStatusDisplay(entryPass.status) }})
          </ng-container>
        </option>
      </select>
      <div class="form-text text-danger">{{ errors.entry_pass_id }}</div>
    </div>

    <div class="form-group">
      <label for="entry_pass_status">Status</label>
      <select id="entry_pass_status"
              name="entry_pass_status"
              class="custom-select"
              [(ngModel)]="condition.parameters.entry_pass_status">
        <option [ngValue]="undefined">
          Any Status
        </option>
        <option [ngValue]="CustomerEntryPassStatus.active">
          {{ getCustomerEntryPassStatusDisplay(CustomerEntryPassStatus.active) }}
        </option>
        <option [ngValue]="CustomerEntryPassStatus.depleted">
          {{ getCustomerEntryPassStatusDisplay(CustomerEntryPassStatus.depleted) }}
        </option>
        <option [ngValue]="CustomerEntryPassStatus.expired">
          {{ getCustomerEntryPassStatusDisplay(CustomerEntryPassStatus.expired) }}
        </option>
        <option [ngValue]="CustomerEntryPassStatus.removed">
          {{ getCustomerEntryPassStatusDisplay(CustomerEntryPassStatus.removed) }}
        </option>
      </select>
      <div class="form-text text-danger">{{ errors.entry_pass_status }}</div>
    </div>

  </ng-container>

  <ng-container *ngIf="condition.condition_type === CustomInboxConditionType.activeMembershipStatus">

    <div class="form-group">
      <label for="has_active_membership">Condition</label>
      <select id="has_active_membership"
              name="has_active_membership"
              class="custom-select"
              [(ngModel)]="condition.parameters.has_active_membership">
        <option [ngValue]="true">Has active membership</option>
        <option [ngValue]="false">Does not have active membership</option>
      </select>
    </div>

    <div class="form-group">
      <label for="membership_id">Membership Type</label>
      <select id="membership_id"
              name="membership_id"
              class="custom-select"
              [(ngModel)]="condition.parameters.membership_id">
        <option [ngValue]="undefined">
          Any Type
        </option>
        <option *ngFor="let membership of memberships"
                [ngValue]="membership.id">
          {{ membership.name }}
          <ng-container *ngIf="membership.status !== MembershipStatus.active">
            ({{ getMembershipStatusDisplay(membership.status) }})
          </ng-container>
        </option>
      </select>
      <div class="form-text text-danger">{{ errors.membership_id }}</div>
    </div>

  </ng-container>

  <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button class="btn btn-primary"
          (click)="handleSubmit()">
    Submit
  </button>
</div>
